import React from 'react';
import { useHistory } from 'react-router';
import Modal from '../components/Modal';
import useQueryString from '../utils/useQueryString';

// 토스 카드 등록창에서 실패/취소로 돌아오는 페이지
const BillingFail = () => {
  const history = useHistory();
  const query = useQueryString();

  return (
    <Modal
      open={true}
      onClose={() => history.push('/')}
      firstButtonLabel="확인"
      onClickFirstButton={() => history.push('/')}
      title="카드 등록 실패"
      content={<>{query.message || '카드 등록이 완료되지 않았습니다.'}</>}
    />
  );
};

export default BillingFail;
